export default __webpack_public_path__ + "static/media/2cd43b_3db08e46b877415c8de6bb208c9d05d1_mv2.601dd436.png";